import { CALENDAR_DAY_VIEW } from 'data/lib/mini-app-constants/commonEventSourceConstants';
import { CalendarNavigationMode } from 'fabric-calendar';
import { onAgendaViewScroll } from 'mini-calendar-agenda-store/lib/actions/publicActions';
import { orchestrator } from 'satcheljs';
import { toggleNavigationMode } from '../actions/toggleNavigationMode';
import {
    CALENDAR_AGENDA_VIEW,
    CALENDAR_DAY_VIEW_ALL_DAY_WELL,
} from 'mini-calendar-utils/lib/eventSourcesConstants';
import {
    onDayViewScroll,
    onAllDayViewExpandCollapse,
} from 'mini-calendar-dayview-store/lib/actions/publicActions';

const toggleToWeekMode = (source: string) => {
    toggleNavigationMode(CalendarNavigationMode.Week, source);
};

/**
 * Mutate navigation mode when agenda view is scrolled by user
 */
export const onAgendaViewScrollOrchestrator = orchestrator(onAgendaViewScroll, () =>
    toggleToWeekMode(CALENDAR_AGENDA_VIEW)
);

/**
 * Mutate navigation mode when day view is scrolled by user
 */
export const onDayViewScrollOrchestrator = orchestrator(onDayViewScroll, () =>
    toggleToWeekMode(CALENDAR_DAY_VIEW)
);

/**
 * Mutate navigation mode when all day well is expanded or collapsed by the user
 */
export const onAllDayViewExpandCollapseOrchestrator = orchestrator(onAllDayViewExpandCollapse, () =>
    toggleToWeekMode(CALENDAR_DAY_VIEW_ALL_DAY_WELL)
);
